const routes = [
  {
    path: '/',
    name: 'home',
    component: {
      render(h) {
        return h('div');
      }
    },
    meta: {
      title: 'Home | BetterMynd'
    }
  },
  {
    path: '/index-(.+.html)',
    name: 'home-hash',
    component: {
      render(h) {
        return h('div');
      }
    },
    meta: {
      title: 'Home | BetterMynd'
    }
  },
  {
    path: '/account',
    name: 'account',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/users/account/Account.vue'),
    meta: {
      title: 'My Account | BetterMynd'
    }
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: () =>
      import('@/college-admin/account/CollegeAdminAccount.vue'),
    meta: {
      title: 'My Account | BetterMynd',
      layout: 'dashboard-layout'
    }
  },
  {
    path: '/availability',
    name: 'availability',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/calendars/CalendarsConfig.vue'),
    meta: {
      title: 'My Availability | BetterMynd'
    }
  },
  {
    path: '/third-party-link-complete',
    name: 'third-party-link-complete',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/calendars/ThirdPartyLinkComplete.vue'),
    meta: {
      title: 'Linking Complete | BetterMynd'
    }
  },
  {
    path: '/counselor/view/:id',
    name: 'view-counselor',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/ViewCounselor.vue'),
    meta: {
      title: 'Counselor | BetterMynd'
    }
  },
  {
    path: '/counselor/profile/:id',
    name: 'counselor-view-counselor-profile',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/profile/Profile.vue'),
    meta: {
      title: 'My Profile | BetterMynd'
    }
  },
  {
    path: '/student/counselor/profile/:id',
    name: 'student-view-counselor-profile',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/students/counselor/Profile.vue'),
    meta: {
      title: 'Counselor | BetterMynd'
    }
  },
  {
    path: '/student/:id',
    name: 'view-student',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/patients/detail/PatientDetail.vue'),
    meta: {
      title: 'Student | BetterMynd'
    }
  },
  {
    path: '/profile/',
    name: 'student-profile',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/students/profile/StudentProfile.vue'),
    meta: {
      title: 'My Profile | BetterMynd'
    }
  },
  {
    path: '/accounts',
    component: () =>
      import(
        /* webpackChunkName: "superadmin-accounts" */ '@/bettermynd-admin/accounts/SuperAdminAccounts.vue'
      ),
    children: [
      {
        path: '',
        redirect: { name: 'accounts-colleges' }
      },
      {
        path: 'colleges',
        name: 'accounts-colleges',
        component: () =>
          import(
            /* webpackChunkName: "superadmin-accounts" */ '@/bettermynd-admin/accounts/SuperAdminColleges.vue'
          ),
        meta: {
          title: 'Colleges | BetterMynd'
        }
      },
      {
        path: 'college-admins',
        name: 'accounts-college-admins',
        component: () =>
          import(
            /* webpackChunkName: "superadmin-accounts" */ '@/bettermynd-admin/accounts/SuperAdminCollegeAdmins.vue'
          ),
        meta: {
          title: 'College Admins | BetterMynd'
        }
      },
      {
        path: 'counselors',
        name: 'accounts-counselors',
        component: () =>
          import(
            /* webpackChunkName: "superadmin-accounts" */ '@/bettermynd-admin/accounts/SuperAdminCounselors.vue'
          ),
        meta: {
          title: 'Counselors | BetterMynd'
        }
      },
      {
        path: 'students',
        name: 'accounts-students',
        component: () =>
          import(
            /* webpackChunkName: "superadmin-accounts" */ '@/bettermynd-admin/accounts/SuperAdminStudents.vue'
          ),
        meta: {
          title: 'Students | BetterMynd'
        }
      }
    ]
  },
  {
    path: '/appointments',
    name: 'admin-appointments',
    component: () =>
      import(
        /* webpackChunkName: "contact" */ '@/bettermynd-admin/appointment-reports/SuperAdminAppointments.vue'
      ),
    meta: {
      title: 'Sessions | BetterMynd'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Contact.vue'),
    meta: {
      title: 'Contact Us | BetterMynd'
    }
  },
  {
    path: '/events',
    name: 'events',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/views/CollegeEvents.vue'),
    meta: {
      title: 'College Events | BetterMynd'
    }
  },
  {
    path: '/counselors',
    name: 'counselors',
    component: () =>
      import(
        /* webpackChunkName: "contact" */ '@/students/counselor-search/CounselorSearch.vue'
      ),
    meta: {
      title: 'Counselors | BetterMynd'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Dashboard.vue'),
    meta: {
      title: 'Dashboard | BetterMynd'
    }
  },
  {
    path: '/dashboard/user',
    name: 'student-dashboard',
    component: () =>
      import(
        /* webpackChunkName: "contact" */ '@/students/dashboard/StudentDashboard.vue'
      ),
    meta: {
      title: 'Dashboard | BetterMynd'
    }
  },
  {
    path: '/dashboard/counselor',
    name: 'counselor-dashboard',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/counselor/dashboard/CounselorDashboard.vue'
      ),
    meta: {
      title: 'Counselor Dashboard | BetterMynd'
    }
  },
  {
    path: '/dashboard/college',
    name: 'college-dashboard',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/college-admin/dashboard/CollegeAdminDashboard.vue'
      ),
    meta: {
      title: 'College Dashboard | BetterMynd',
      layout: 'dashboard-layout'
    }
  },
  {
    path: '/dashboard/admin',
    name: 'admin-dashboard',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/bettermynd-admin/dashboard/SuperAdminDashboard.vue'
      ),
    meta: {
      title: 'Administrative Dashboard | BetterMynd'
    }
  },
  {
    path: '/inbox',
    name: 'inbox',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Inbox.vue'),
    meta: {
      title: 'Inbox | BetterMynd'
    }
  },
  {
    path: '/clients',
    name: 'clients',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/patients/Clients.vue'),
    meta: {
      title: 'Clients | BetterMynd'
    }
  },
  {
    path: '/payments',
    name: 'payments',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Payments.vue'),
    meta: {
      title: 'My Payments | BetterMynd'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: {
      mounted() {
        this.$globals.keycloak.logout({ redirectUri: window.location.origin });
        this.$globals.keycloak.register({ redirectUri: window.location.origin });
      }
    },
    meta: {
      title: 'Welcome | BetterMynd',
      layout: 'no-header-layout'
    }
  },
  {
    path: '/users/link-campus',
    name: 'link-campus',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/students/welcome/LinkCampus/LinkCampus.vue'),
    meta: {
      title: 'Link Campus | BetterMynd',
      layout: 'no-header-layout'
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Resources.vue'),
    meta: {
      title: 'Mental Health Resources | BetterMynd'
    }
  },
  {
    path: '/scheduling',
    name: 'scheduling',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Scheduling.vue'),
    meta: {
      title: 'Scheduling | BetterMynd'
    }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/students/welcome/Welcome.vue'),
    meta: {
      title: 'Welcome | BetterMynd',
      layout: 'no-header-layout'
    }
  },
  {
    path: '/counselor/welcome',
    name: 'counselor-welcome',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/counselor/account/CounselorWelcome.vue'
      ),
    meta: {
      title: 'Welcome | BetterMynd',
      layout: 'no-header-layout'
    }
  },
  {
    path: '/mental-health-survey',
    name: 'mental-health-survey',
    component: () =>
      import(
        /* webpackChunkName: "register" */ '@/surveys/mental-health-survey/MentalHealthSurvey.vue'
      ),
    meta: {
      title: 'Mental Health Survey | BetterMynd',
      layout: 'no-header-layout'
    }
  },
  {
    path: '/sessions/individual/:appointmentId?',
    name: 'sessions-individual',
    component: () =>
      import(
        /* webpackChunkName: "contact" */ '@/counselor/appointments/SessionsIndividual.vue'
      ),
    meta: {
      title: 'My Sessions | BetterMynd'
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/Services.vue'),
    meta: {
      title: 'Services | BetterMynd'
    }
  },
  {
    path: '/workshops/create',
    name: 'create-workshop',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/views/CreateSession.vue'),
    meta: {
      title: 'New Wellbeing Workshop | BetterMynd'
    }
  },
  {
    path: '/bettermynd-admin/workshops:id?',
    name: 'bettermynd-admin-workshops',
    component: () =>
      import(/* webpackChunkName: "bettermynd-admin" */ '@/bettermynd-admin/workshops/WorkshopsList.vue'),
    meta: {
      title: 'Workshops | BetterMynd'
    }
  },
  {
    path: '/workshops/:id?',
    name: 'workshops',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/students/workshops/WorkshopsList.vue'),
    meta: {
      title: 'Workshops | BetterMynd'
    }
  },
  {
    path: '/counselor/workshops/:id?',
    name: 'counselor-workshops',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/counselor/workshops/WorkshopsList.vue'),
    meta: {
      title: 'Workshops | BetterMynd'
    }
  },
  {
    path: '/events/create',
    name: 'create-event',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/views/CreateEvent.vue'),
    meta: {
      title: 'Create Event | BetterMynd'
    }
  },
  {
    path: '/stripe/payment/:id/:status', // /stripe/payment/1/success|error
    name: 'stripe-payment-complete',
    component: () => import('@/views/PaymentComplete.vue'),
    meta: {
      title: 'Payment Complete | BetterMynd'
    }
  },
  {
    path: '/college/:id',
    name: 'edit-college',
    component: () =>
      import(/* webpackChunkName: "register" */ '@/bettermynd-admin/edit-college/EditCollege.vue'),
    meta: {
      title: 'Edit College | BetterMynd'
    }
  },
  {
    path: '/survey',
    name: 'survey',
    component: () =>
      import('@/surveys/survey-request-template/SurveyRequestTemplate.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.query.id && !to.query.slug) return next('/');
      return next();
    },
    meta: {
      title: 'Survey | BetterMynd',
      layout: 'survey-layout'
    }
  },
  {
    path: '/thankyou',
    name: 'survey-thank-you',
    component: () => import('@/surveys/thank-you/ThankYou.vue'),
    meta: {
      title: 'Thank You! | BetterMynd',
      layout: 'survey-layout'
    }
  },
  {
    path: '/college/users/session-outcomes',
    name: 'user-outcomes-report',
    component: () => import('@/college-admin/reports/session-outcomes/SessionOutcomes.vue'),
    meta: {
      title: 'Session Outcomes | BetterMynd',
      layout: 'dashboard-layout'
    }
  },
  {
    path: '/users/faq',
    name: 'user-faq',
    component: () => import('@/students/faq/faq.vue'),
    meta: {
      title: 'F.A.Q. | BetterMynd',
    }
  },
  {
    path: '/bettermynd-admin/reports/feedback',
    name: 'bettermynd-admin-feedback-report',
    component: () => import('@/bettermynd-admin/reports/feedback/feedback.vue'),
    meta: {
      title: 'BetterMynd | Reports | Feedback',
    }
  },
  {
    path: '/bettermynd-admin/payroll',
    name: 'bettermynd-admin-payroll',
    component: () => import('@/bettermynd-admin/payroll/payroll.vue'),
    meta: {
      title: 'BetterMynd | Payroll',
    }
  },

];

export default routes;
